import absenceTypes from "./absence.types";

interface IAbsenceReducerState {
  list: any,
  itemSelected: any,
  loading: boolean,
  error: string
}

const INITIAL_STATE = {
  list: [],
  itemSelected: {},
  loading: false,
  error: ""
};

const absenceReducer = (
  state: IAbsenceReducerState = INITIAL_STATE,
  action: any
): IAbsenceReducerState => {
  switch (action.type) {
    case absenceTypes.GET_ABSENCE_LIST:
      return {
        ...state,
        list: action.payload,
        error: ""
      };

    case absenceTypes.SELECTED_ABSENCE:
      return {
        ...state,
        itemSelected: action.payload,
        error: ""
      };
    
    case absenceTypes.LOADING:
      return {
        ...state,
        loading: action.payload,
        error: ""
      };

    default:
      return state;
  }
};

export default absenceReducer;
